<template>
  <div>
    <el-dialog
      title="订单确认"
      :visible.sync="orderConfirmationVisible"
      :close-on-click-modal="false"
      :z-index="99999"
      append-to-body
      width="600px"
      @close="close">
      <el-table :data="orderConfirmationList" class="base-margin__bottom-20 base-min-height__300" max-height="400">
        <el-table-column :label="$t('customCluster.addInstanceDialog.instanceType')" prop="instanceType"></el-table-column>
        <el-table-column :label="$t('createNode.nodeCount')" prop="nodeCount"></el-table-column>
        <el-table-column :label="$t('createNode.nodePrice')">
          <template slot-scope="scope">
                <span class="base-color__orange">
                  <span>
                    {{ scope.row.nodePrice }} {{ scope.row.priceUnit }}
                  </span>
                </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('createNode.totalPrice')">
          <template slot-scope="scope">
                  <span class="base-color__orange">
                    <span>
                      {{ scope.row.totalPrice }} {{ scope.row.priceUnit }}
                    </span>
                  </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderConfirmationVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="finishOrder">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'name',
  data() {
    return {
      orderConfirmationVisible: false,
      orderConfirmationList: [],
      info: {}
    };
  },

  methods: {
    // js函数

    // 获取数据 展示弹窗
    showOrderConfirmation(info) {
      this.info = info;
      this.orderConfirmationList = info.list;
      this.orderConfirmationVisible = true;
    },

    // finishOrder 完成订单
    finishOrder() {
      if (this.info.type) {
        this.$emit('finishOrder', this.info.functionInfo);
      } else {
        this.$emit('finishOrder');
      }
      this.orderConfirmationList = [];
      this.orderConfirmationVisible = false;
    },
    // 关闭弹窗
    close() {
      this.orderConfirmationList = [];
      this.orderConfirmationVisible = false;
    }
  },
};
</script>
<style lang="scss">

</style>
